<template>
  <div>
    <v-card-text>
      <v-container fill-height fluid>
        <v-row justify="center">
          <v-col cols="12" lg="6" md="6">
            <h2 class="mb-4" style="text-align:center">Employee Certificates</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="6" md="6"  v-for="(certificate, itemKey) in employeeCertificates" :key="itemKey" style="max-width:48%;" class="mx-3 py-0 mb-3 elevation-2">
            <div>
              <v-card-title class="pb-0 justify-space-between">
                <h5>
                  {{ certificate.Certificate_Title }}
                </h5>
                <v-btn
                  small
                  icon
                  color="primary"
                  v-if="currentUser || canEditByRole"
                  @click="onCertificateClick(certificate)"
                >
                  <v-icon>mdi-pencil-circle</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-col cols="12" lg="12" md="12">
                  <v-row>
                    <v-col cols="12" md="5" lg="5">
                      <h5> Description </h5>
                      <h4> {{ certificate.Description }} </h4>
                    </v-col>
                    <v-col cols="12" md="3" lg="3">
                      <h5> Date of Receiving </h5>
                      <h4> {{ formatLocalDate(certificate.Date_of_Receiving) }} </h4>
                    </v-col>
                    <v-col cols="12" md="4" lg="4">
                      <h5> File or Link </h5>
                      <h4>
                        <a
                          :href="certificate.File_Name"
                          target="_blank"
                          rel="noopener noreferrer"
                          v-if="isLink(certificate.File_Name)"
                        >
                          {{certificate.File_Name}}
                        </a>
                        <span
                          style="cursor: pointer"
                          v-else
                          @click="openCertificate(certificate)"
                        >
                          {{certificate.File_Name}}
                        </span>
                      </h4>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card-text>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
            <v-btn
              v-if="currentUser || canEditByRole"
              color="success"
              small
              class="mr-5"
              @click.prevent="addNewCertificate"
            >
              Add
            </v-btn>
        </v-row>
      </v-container>
    </v-card-text>
    <!-- Certificate dialog -->
    <v-dialog
      v-model="showCertificateDetails"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Certificate Details
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="showCertificateDetails = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="7" lg="7">
              <h5> Certificate Name </h5>
              <v-text-field
                v-model="selectedCertificate.Certificate_Title"
                :readonly="!editMode"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="5" lg="5">
              <h5 class="color-black">Date of Receiving</h5>
              <DatePicker
                v-if="editMode"
                v-model="formattedDateForPicker"
                @input="updateDate"
              />
              <v-text-field
                v-else
                :value="formattedDateForPicker"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="7" lg="7">
              <h5>File or Link</h5>
              <v-text-field
                v-model="selectedCertificate.File_Name"
                :readonly="!editMode"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5" lg="5">
              <v-btn
                v-if="editMode"
                color="primary"
                class="mt-8"
                outlined
                small
                depressed
                @click="uploadFile"
              >
                Upload
                <v-icon class="pl-1">
                  mdi-18px
                  mdi-upload
                </v-icon>
                <v-file-input
                  id="uploader"
                  class="d-none"
                  hide-input
                  @change="onFileChange"
                  v-model="selectedCertificate.Certificate"
                  accept="application/pdf"
                >
                </v-file-input>
              </v-btn>
              <v-btn
                v-else
                class="mt-8"
                outlined
                small
                color="primary"
                :disabled="!selectedCertificate.File_Type || selectedCertificate.File_Type === 'null'"
                @click.prevent="openCertificate(selectedCertificate)"
              >
                Open
                <v-icon class="pl-1">
                  mdi-18px
                  mdi-open-in-new
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="8" md="8">
              <h5>Description</h5>
              <v-textarea
                v-model="selectedCertificate.Description"
                :readonly="!editMode"
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>
        <v-card-actions>
          <v-btn small v-if="!editMode" color="red darken-2 white--text" :disabled="!(currentUser || canEditByRole)" @click.prevent="removeDialog = true">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" :disabled="!(currentUser || canEditByRole)" @click.prevent="editCurrentCertificate">{{ editMode ? 'Save' : 'Edit' }}</v-btn>
        </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- /Certificate dialog -->
     <!-- Remove dialog -->
    <ConfirmOrDeniedDialog
      v-if="removeDialog"
      v-model="removeDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      :message="'Do you want to delete current certificate?'"
      @onDeleteClick="deleteCurrentCertificate"
      @onCancelClick="removeDialog = false"
    />
    <!-- /Remove dialog -->
  </div>
</template>
<script>
import { getApiErrorMessage } from '@/utils/apiError'
import { formatLocalDate } from '@/utils/dateUtils'
export default {
  name: 'EmployeeCertificates',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue'),
    DatePicker: () => import('@/components/global/DatePicker.vue')
  },
  props: {
    value: {
      required: false,
      type: Boolean,
      default: false
    },
    employee: {
      required: false,
      default: null
    },
    rolesOfUser: {
      required: false,
      default: null
    }
  },
  data () {
    return {
      addMode: false,
      editMode: false,
      employeeCertificates: [],
      certificateDialog: false,
      selectedCertificate: {
        Certificate_ID: null,
        Employee_ID: this.employee.Employee_ID,
        Certificate_Title: '',
        Description: '',
        Date_of_Receiving: null,
        File_Name: '',
        Certificate: null,
        File_Type: null,
        S3_Name: null,
        Location: null
      },
      removeDialog: false,
      downloadLink: document.createElement('a')
    }
  },
  computed: {
    formattedDateForPicker: {
      get () {
        const date = this.selectedCertificate.Date_of_Receiving
        return date ? date.slice(0, 10) : ''
      },
      set (value) {
        this.selectedCertificate.Date_of_Receiving = value
      }
    },
    showCertificateDetails: {
      get () {
        return this.certificateDialog
      },
      set (val) {
        if (!val) {
          this.addMode = false
          this.editMode = false
        }
        this.certificateDialog = val
      }
    },
    isLink () {
      return url => {
        // eslint-disable-next-line no-useless-escape
        const regex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/.test(url)
        return regex
      }
    },
    user () {
      return this.$store.getters.getUser
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    currentUser () {
      let res = false
      if (this.employee) {
        res = this.user.employee_id === this.employee.Employee_ID
      } else {
        res = false
      }
      return res
    },
    canEditByRole () {
      let res = false
      if (this.rolesOfUser) {
        for (let i = 0; i < this.rolesOfUser.length; i++) {
          if (this.rolesOfUser[i].RoleName === 'HR' || this.rolesOfUser[i].RoleName === 'financier') {
            res = true
            break
          }
        }
      }
      return res
    },
    linkToCertificate () {
      let res = ''
      if (this.selectedCertificate.File_Type && this.selectedCertificate.Certificate && this.selectedCertificate.Certificate.data) {
        let binary = ''
        const bytes = new Uint8Array(this.selectedCertificate.Certificate.data)
        const len = bytes.byteLength
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        res = `data:${this.selectedCertificate.File_Type};base64, ${window.btoa(binary)}`
      }
      return res
    }
  },
  mounted () {
    this.getEmployeeCertificates()
  },
  methods: {
    formatLocalDate,
    updateDate (value) {
      this.selectedCertificate.Date_of_Receiving = value ? value.slice(0, 10) : ''
    },
    getEmployeeCertificates () {
      this.axios.get(`/api/employee_certificates/${this.employee.Employee_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.employeeCertificates = result.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    async getEmployeeCertificateById (id) {
      await this.axios.get(`/api/employee_certificate/${id}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.selectedCertificate = result.data[0]
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    async onCertificateClick (certificate) {
      if (certificate.S3_Name) {
        this.selectedCertificate = this.employeeCertificates.find((cert) => cert.Certificate_ID === certificate.Certificate_ID)
      } else {
        await this.getEmployeeCertificateById(certificate.Certificate_ID)
      }
      this.showCertificateDetails = true
      this.addMode = false
    },
    addNewCertificate () {
      this.clearCurrentCertificate()
      this.addMode = true
      this.editMode = true
      this.showCertificateDetails = true
    },
    clearCurrentCertificate () {
      this.selectedCertificate.Certificate_ID = null
      this.selectedCertificate.Employee_ID = this.employee.Employee_ID
      this.selectedCertificate.Certificate_Title = ''
      this.selectedCertificate.Description = ''
      this.selectedCertificate.Date_of_Receiving = null
      this.selectedCertificate.File_Name = ''
      this.selectedCertificate.Certificate = null
      this.selectedCertificate.File_Type = null
    },
    editCurrentCertificate () {
      if (this.addMode) {
        const body = {
          Employee_ID: this.selectedCertificate.Employee_ID,
          Certificate_Title: this.selectedCertificate.Certificate_Title,
          Description: this.selectedCertificate.Description,
          Date_of_Receiving: this.selectedCertificate.Date_of_Receiving,
          File_Type: this.selectedCertificate.File_Type,
          File_Name: this.selectedCertificate.File_Name.trim(),
          File: this.selectedCertificate.Certificate
        }
        const formData = new FormData()
        Object.entries(body).forEach(([key, value]) => {
          formData.append(key, value)
        })
        this.axios.post('/api/employee_certificate', formData, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(result => {
          this.selectedCertificate.Certificate_ID = result.data[0].Certificate_ID
          this.employeeCertificates.push(result.data[0])
          this.showCertificateDetails = false
          this.$store.dispatch('setSuccess', { successMsg: 'Certificate successfully added' })
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      } else if (this.editMode) {
        const body = {
          Certificate_Title: this.selectedCertificate.Certificate_Title,
          Description: this.selectedCertificate.Description,
          Date_of_Receiving: this.selectedCertificate.Date_of_Receiving,
          File_Type: this.selectedCertificate.File_Type,
          File_Name: this.selectedCertificate.File_Name.trim(),
          S3_Name: this.selectedCertificate.S3_Name,
          Location: this.selectedCertificate.Location,
          File: this.selectedCertificate.Certificate
        }
        const formData = new FormData()
        Object.entries(body).forEach(([key, value]) => {
          formData.append(key, value)
        })
        this.axios.put(`/api/employee_certificate/${this.selectedCertificate.Certificate_ID}`, formData, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(result => {
          this.getEmployeeCertificates()
          this.showCertificateDetails = false
          this.$store.dispatch('setSuccess', { successMsg: 'Certificate successfully updated' })
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      } else {
        this.editMode = true
      }
    },
    deleteCurrentCertificate () {
      this.axios.delete(`/api/employee_certificate/${this.selectedCertificate.Certificate_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.getEmployeeCertificates()
        this.removeDialog = false
        this.showCertificateDetails = false
        this.$store.dispatch('setSuccess', { successMsg: 'Certificate successfully deleted' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    onFileChange (e) {
      const { name, extension } = this.parseFileNameAndExtension(e.name)
      this.selectedCertificate.File_Name = name
      this.selectedCertificate.File_Type = extension
    },
    parseFileNameAndExtension (fullFileName) {
      const name = fullFileName
      const extension = fullFileName.split('.').pop()
      return {
        name,
        extension
      }
    },
    getLinkToCertificate (cert) {
      let res = ''
      if (cert.File_Type && cert.Certificate && cert.Certificate.data) {
        let binary = ''
        const bytes = new Uint8Array(cert.Certificate.data)
        const len = bytes.byteLength
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        res = `data:${cert.File_Type};base64, ${window.btoa(binary)}`
      }
      return res
    },
    async openCertificate (cert) {
      if (cert.S3_Name && cert.S3_Name !== 'undefined') {
        this.axios.get(`/api/document/${cert.S3_Name}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          const contentType = res.data.ContentType
          const buffer = res.data.Body.data
          this.openFile(cert.File_Name, buffer, contentType)
        }).catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
      } else if (cert.Certificate_ID) {
        await this.getEmployeeCertificateById(cert.Certificate_ID).then(() => {
          const win = window.open()
          if (!win) {
            this.$store.dispatch('setError', { errorMsg: 'Please allow popups' })
            return
          }

          win.document.write('<iframe src="' + this.linkToCertificate + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>')
        })
      } else {
        const win = window.open()
        if (!win) {
          this.$store.dispatch('setError', { errorMsg: 'Please allow popups' })
          return
        }

        win.document.write('<iframe src="' + this.linkToCertificate + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>')
      }
    },
    openFile (filename, data, type) {
      const linkSource = this.linkToFile(data, type)
      this.downloadLink.href = linkSource
      this.downloadLink.download = filename
      this.downloadLink.click()
    },
    linkToFile (data, type) {
      let res = ''
      let binary = ''
      const bytes = new Uint8Array(data)
      const len = bytes.byteLength
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      res = `data:${type};base64, ${window.btoa(binary)}`
      return res
    },
    uploadFile () {
      document.getElementById('uploader').click()
    }
  }
}
</script>
